import { render, staticRenderFns } from "./RepurchaseAttention.vue?vue&type=template&id=6cb2efe0&"
import script from "./RepurchaseAttention.vue?vue&type=script&lang=js&"
export * from "./RepurchaseAttention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports